import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { useAuthentication } from '@zenbusiness/application-commons-authentication';
import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useExperimentFlag } from '@zenbusiness/application-commons-experiments';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { DEFAULT_SEGMENT } from '#client/build-env';
import { OrphanAccountRedirect } from '#client/components/OrphanAccountRedirect';
import { ENABLE_ORPHAN_ACCOUNTS_REDIRECT } from '#client/constants/experimentsFlags';

export default function Landing() {
  const { authenticated, login } = useAuthentication();
  const { loading: entityLoading, businessEntityUuid } = useBusinessEntity();
  const enableOrphanAccountsRedirect = useExperimentFlag(ENABLE_ORPHAN_ACCOUNTS_REDIRECT, false);
  const [shouldRedirectOrphanAccount, setShouldRedirectOrphanAccount] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (!authenticated) {
      login(`${DEFAULT_SEGMENT}/`);
      return;
    }
    if (!entityLoading && businessEntityUuid) {
      navigate(`${DEFAULT_SEGMENT}/${businessEntityUuid}/`);
    }

    // Check for orphan account redirect if no business entity
    if (!entityLoading && !businessEntityUuid) {
      setShouldRedirectOrphanAccount(true);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, entityLoading, businessEntityUuid]);

  if (shouldRedirectOrphanAccount && enableOrphanAccountsRedirect) {
    return <OrphanAccountRedirect />;
  }

  return <PageLoading />;
}
